var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoExpandedWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2",
    "data-name": "Grupo 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1897.556 556.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1",
    "data-name": "Rect\\xE1ngulo 1",
    width: 1897.556,
    height: 556.215,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M940.635,92.631c-2.794,1.3-4.79,2.495-6.885,3.293-12.972,4.59-25.945,9.081-39.815,13.97-14.469-25.346-35.125-41.212-64.263-45-20.057-2.594-38.917-.2-56.48,9.879-36.522,21.055-52.488,66.957-37.819,108.07,14.27,40.015,55.083,62.367,99.787,55.282,33.429-5.389,60.97-37.221,59.274-59.773H804.824c-1-16.166-.5-31.134-.4-45.9,10.677-3.293,119.944-4.391,143.893-1.5a141.852,141.852,0,0,1-1.1,53.087C933.65,248.5,882.958,288.613,816.6,289.412c-70.25.8-116.751-45.4-131.819-87.314-31.633-88.312,22.053-168.541,96.894-184.906C820.89,8.61,858.31,14,893.236,34.056,916.187,47.228,932.253,67.085,940.635,92.631Z",
    transform: "translate(-1.436 -0.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M1341.2.8h49.1c1.6,16.664.6,33.129.8,49.594.2,16.066,0,32.132,0,50.293,5.089-2.495,8.282-3.892,11.376-5.588,72.944-40.314,146.987,10.478,150.579,81.925,1,20.756-1.2,40.913-11.276,59.473-28.339,52.588-83.921,64.662-132.019,43.208-5.488-2.495-10.677-5.688-16.964-8.981-1.2,4.391-2.1,7.883-3.193,12.174h-47.7C1339.2,272.721,1338.3,22.953,1341.2.8Zm161.256,185.305c.1-29.138-13.671-49.993-37.819-57.278-29.038-8.781-60.97,7.085-69.552,36.223-10.677,36.223,4.49,65.261,34.626,75.838,39.416,13.87,74.84-15.367,72.745-54.783",
    transform: "translate(-2.848 -0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M1738.557,100.758c.8-5.289,1.3-8.582,1.9-12.673h49.993V282.97h-49.694c-.7-3.293-1.4-7.185-2.1-10.378-13.372,4.989-25.745,11.176-38.917,14.369-58.675,13.97-112.959-24.248-120.743-84.121-4.49-34.926,3.193-65.86,27.841-92.1,33.828-36.023,83.422-35.524,118.148-17.662,4.091,2,8.083,4.49,13.571,7.684m-56.08,143.394c31.932.1,56.879-25.346,56.979-58.376.1-32.63-25.346-59.473-56.38-59.473-32.132-.1-55.382,25.047-55.282,59.573.2,34.327,22.552,58.176,54.683,58.276",
    transform: "translate(-3.355 -0.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M1086.2,183.883c.1-60.172,48.2-102.981,109.167-101.683,62.966,1.4,107.172,48.3,103.879,109.567-2.994,57.278-49.295,99.089-110.365,97.293-59.872-1.8-104.278-47.2-102.681-105.176m106.972,60.272c31.034,0,55.981-25.645,56.28-58.076.3-31.832-25.047-58.875-55.482-59.274-31.533-.4-57.078,25.546-57.577,58.475C1135.894,217.911,1161.14,244.155,1193.172,244.155Z",
    transform: "translate(-2.31 -0.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M996,0h49.395V283.7h-48C994,272.819,992.7,26.444,996,0Z",
    transform: "translate(-2.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M1848.9.9h49.495V282.8h-48.4C1846.9,272.621,1845.8,23.552,1848.9.9",
    transform: "translate(-3.928 -0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M325.489,248.5V454.162a49.594,49.594,0,0,1-99.189,0V248.5Z",
    transform: "translate(-0.481 -0.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M188.989,248.5V507.149a49.594,49.594,0,1,1-99.189,0V248.5Z",
    transform: "translate(-0.191 -0.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M465.489,248.5V406.563a49.594,49.594,0,0,1-99.189,0V248.5Z",
    transform: "translate(-0.779 -0.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M552.123,132.342V54.009a25,25,0,0,0-.6-5.488A38.439,38.439,0,0,0,513.206,11.3H38.418A37.832,37.832,0,0,0,11.376,22.576,38.511,38.511,0,0,0,0,49.618a36.285,36.285,0,0,0,.3,4.79A25.55,25.55,0,0,0,5.688,69.676a38.308,38.308,0,0,0,32.63,18.261H63.465v22.153a5.792,5.792,0,0,0,5.788,5.788h2.1a5.792,5.792,0,0,1,5.788,5.788v5.588a5.792,5.792,0,0,0,5.788,5.788h2.994v84.42H466.805v-84.52a4.858,4.858,0,0,0,1.2.1h11.276c2.894,0,5.189-1.9,5.189-4.191v-8.781c0-2.3,2.3-4.191,5.189-4.191s5.189-1.9,5.189-4.191V87.937h18.56a38.382,38.382,0,0,0,25.945-10.178v54.185A21.044,21.044,0,0,0,524.283,152.1v21.055h42.01V152.1a21.174,21.174,0,0,0-14.17-19.758",
    transform: "translate(0 -0.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M1095.7,468.023a50.681,50.681,0,0,1-10.677,10.478,51.889,51.889,0,1,1-31.134-93.4,50.733,50.733,0,0,1,30.834,10.478A53.281,53.281,0,0,1,1095,405.956l-7.185,6.486a38.388,38.388,0,0,0-8.382-8.682,39.923,39.923,0,0,0-25.546-8.681c-23.051,0-41.112,18.061-41.112,41.811s18.061,41.811,41.112,41.811a41.6,41.6,0,0,0,25.945-8.681,42.112,42.112,0,0,0,8.682-8.682Z",
    transform: "translate(-2.131 -0.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M1204.21,386.5h10.078L1256.1,487.485h-11.575l-11.575-28.14h-47.6l-11.575,28.14H1162.2Zm24.548,62.766-19.459-47.6-19.458,47.6Z",
    transform: "translate(-2.471 -0.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M1332.2,386.5h9.38l41.811,54.783L1425.2,386.5h9.38V487.485H1423.8V405.26l-40.414,53.386-40.414-53.386v82.225H1332.2Z",
    transform: "translate(-2.833 -0.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M1523,386.5h38.219c18.76,0,32.431,13.87,32.431,31.732s-13.671,31.732-32.431,31.732h-27.442v37.52H1523Zm38.219,53.386c13.172,0,21.654-8.482,21.654-21.654s-8.482-21.654-21.654-21.654h-27.442v43.308Z",
    transform: "translate(-3.239 -0.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M1673.4,386.5h10.777v61.269c0,18.061,12.972,31.034,30.335,31.034s30.335-12.972,30.335-31.034V386.5h10.777v61.269a41.112,41.112,0,0,1-82.225,0Z",
    transform: "translate(-3.558 -0.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M1840.286,466.426a27.752,27.752,0,0,0,6.586,6.187c4.49,3.293,11.376,6.187,20.756,6.187,15.168,0,23.051-7.783,23.051-18.76,0-25.845-54.783-11.675-54.783-47.6,0-14.569,12.374-27.442,32.431-27.442a39.36,39.36,0,0,1,22.053,6.486,33.7,33.7,0,0,1,7.484,6.486l-7.185,7.185a34.26,34.26,0,0,0-5.588-5.089,30.081,30.081,0,0,0-16.764-5.089c-13.87,0-21.654,8.183-21.654,17.263,0,25.945,54.783,11.675,54.783,47.6,0,16.565-12.274,28.839-33.928,28.839-11.575,0-20.057-3.592-25.645-7.484a31.829,31.829,0,0,1-8.182-7.684Z",
    transform: "translate(-3.899 -0.819)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExpandedWhite);
export default __webpack_public_path__ + "static/media/logo_expanded_white.66ea8d52.svg";
export { ForwardRef as ReactComponent };